import { skipToken } from '@reduxjs/toolkit/query/react';

import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';
import { intentDetectionApi } from 'apis/intentDetection';

type RoutedThroughIntentDetectionProps = {
  node: ConversationFlowAuditLogEntry<'INTENT_DETECTION_NODE_VISITED'>;
};

export function RoutedThroughIntentDetection({
  node,
}: RoutedThroughIntentDetectionProps): JSX.Element {
  const { data } = intentDetectionApi.useReadIntentDetectionQuery(
    node.matching_intent_id ? { id: node.matching_intent_id } : skipToken,
  );

  const intentName = data?.name;

  return (
    <>
      Intent detection{' '}
      {intentName && (
        <>
          · <strong> {intentName} </strong>
        </>
      )}
    </>
  );
}
